
module.constant('brandeisActivityFields', [
    "ged_prep",
    "hs_courses",
    "state_test_prep",
    "research_papers",
    "college_math",
    "duel_credit",
    "vocational_classes",
    "other_college_courses",
    "pre_college_support",
    "college_prep",
    "non_college_pse",
    "cohort_building",
    "leadership_activities",
    "financial_literacy",
    "community_service_activities",
]);

module.directive('brandeisExitForm', function(ModelService, brandeisActivityFields) {
    return {
        restrict: 'E',
        templateUrl: 'students/educationProfile/brandeisExitForm',
        scope: {brandeisData: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            var fields = brandeisActivityFields.concat('academic_advising'),
                data = ModelService.copyFields(scope.brandeisData, fields);
            scope.data = basicForm.data = data;
            scope.activityFields = brandeisActivityFields;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.brandeisData, data);
            };
        },
    };
});